@let offersValue = offers();
@let showJobControlValue = showJobControl();

<form [formGroup]="form()" padding>
  @if (showJobControlValue) {
    <rt-evaluation-job-field
      [control]="form().controls.offerId"
      [offers]="offersValue"
      [hasBox]="false"
      label="app.interview.job"
      margin-bottom
    />
  }

  <rt-evaluation-form-control
    [control]="form().controls.templateId"
    [groupedForms]="groupedTemplates()"
    [disabled]="!templatesLoaded()"
  />
</form>
